import { render, staticRenderFns } from "./goodsMaterial.vue?vue&type=template&id=c63e6d2c&"
import script from "./goodsMaterial.vue?vue&type=script&lang=js&"
export * from "./goodsMaterial.vue?vue&type=script&lang=js&"
import style0 from "./goodsMaterial.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports